import { useState } from 'react';

/**
 * Takes an incoming `value` and only changes the returned value if the difference between the
 * incoming and the last returned value is greater than the supplied `threshold`.
 *
 * @param value the current and initial value.
 * @param threshold the amount by which the value must change before the hook returns the updated value.
 */
export function useStickyNumber(value: number, threshold: number) {
    const [num, setNum] = useState(value);

    if (Math.abs(num - value) > threshold) {
        setNum(value);
    }

    return num;
}
